<template>
  <div>
    <el-tabs v-model="form.activeName" type="card">
      <el-tab-pane label="资料完善" name="first">
        <div class='pb-32 pl-16 color-regular-text'>
          <el-space :size="'large'">
             <!-- 版本: {{ form.authority }}&nbsp;&nbsp; -->
            <div v-if="form.expireDate != null && form.expireDate != ''">
              有效期: {{ form.expireDate }}
            </div>
            <el-button type="warning" :icon="Search" @click="handlePayClick">充值</el-button>
          </el-space>
        </div>
        <div class='pb-32' style="padding-left:100px">
          <el-upload class="avatar-uploader" action="upload/avatar" :data="{ 'mobile_number': form.mobileNumber }"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
            :headers="form.headerObj">
            <!-- <el-avatar :size="100" v-if="form.avatar == null || form.avatar == ''" :src= "form.defaultAvatar"/>
            <el-avatar :size="100" v-if="form.avatar != null && form.avatar != ''" :src="'http://localhost:8888' + form.avatar"/> -->
            <el-avatar :size="100" v-if="form.avatar == null || form.avatar == ''" :src="form.defaultAvatar"/>
            <el-avatar :size="100" v-if="form.avatar != null && form.avatar != ''" :src="'https://www.morepoll.com/avatar' + form.avatar"/>
          </el-upload>
        </div>
        <el-form :model="form" label-width="60px">
          <el-form-item label="*昵称">
            <el-input v-model="form.nickname" style="width:250px" maxlength="30" @change="handleInputChange" />
          </el-form-item>
          <el-form-item label="*性别">
            <el-radio-group v-model="form.gender" style="width:250px" @change="handleSelectChange">
              <el-radio label="男" value="1" />
              <el-radio label="女" value="0" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="*生日">
            <el-date-picker v-model="form.birthday" type="date" placeholder="请选择" format="YYYY/MM/DD"
              value-format="YYYY-MM-DD" style="width:250px" @change="handleSelectChange" />
          </el-form-item>
          <el-form-item label="*地区">
            <el-select v-model="form.region" placeholder="请选择" style="width:250px" @change="handleSelectChange">
              <el-option v-for="item in form.regionList" :label="item" :value="item" :key="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="form.email" style="width:250px" maxlength="30" @change="handleInputChange" />
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="form.wx" style="width:250px" maxlength="30" @change="handleInputChange" />
          </el-form-item>
          <el-form-item label="QQ">
            <el-input v-model="form.qq" style="width:250px" maxlength="30" @change="handleInputChange" />
          </el-form-item>
          <el-form-item label="简介">
            <el-input v-model="form.desc" type="textarea" rows="7" resize="none" height="200" style="width:250px"
              maxlength="100" @change="handleInputChange" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="消息通知" name="second">
        <el-table :data="form.messageList" style="width: 1200px" empty-text=" " :cell-style="cellStyle"
          @row-click="handleMsgClick">
          <el-table-column fixed label="消息内容" prop="title" width="600px" />
          <el-table-column fixed label="接收时间" prop="date" width="200px" />
          <el-table-column label="消息类型" prop="category" width="200px" />
          <el-table-column label="状态" prop="readed" width="200px" />
        </el-table>
        <el-pagination background layout="prev, pager, next" :total="form.total" :current-page="form.page" class="mt-16"
          @current-change="handlePageChange"></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <el-drawer v-model="form.drawer" title="I am the title" :with-header="false" :size="'800px'" @closed="handleClosed">
      <div class='ariticle' ref="drawerPage">
        <div class="ariticle-title">
          <span>{{ form.title }}</span>
        </div>
        <div class="ariticle-subtitle">
          <span>{{ form.date }}&nbsp;&nbsp;&nbsp;&nbsp;{{ form.category }}</span>
        </div>
        <div class="ariticle-content">
          <div v-html="form.content"></div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive, ref, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
import { LStorage } from '../util/storage'
import defaultAvatar from "../assets/df.png"

export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const router = useRouter()
    const drawerPage = ref()
    const form = reactive({
      mobileNumber: LStorage.getItem('user'),
      headerObj: { auth: LStorage.getItem('auth') },
      authority: '',
      expireDate: '',
      avatar: '',
      defaultAvatar: defaultAvatar,
      nickname: '',
      gender: '',
      birthday: '',
      region: '',
      regionList: ["北京", '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西', '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门', '其他', '海外'],
      email: '',
      wx: '',
      qq: '',
      desc: '',
      formStr: '',
      activeName: 'first',
      messageList: [],
      total: 0,
      page: 1,
      limit: 10,
      drawer: false,
      title: '',
      date: '',
      content: '',
      category: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '21')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.meData === '') {
        // 无缓存，从后台请求数据
        requestData()
        requestMsgData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData = () => {
      http({
        url: `/user`,
        method: 'post'
      }).then((res) => {
        console.log(res)
        processData(res)
        setStore()
      })
    }

    // 处理数据
    const processData = (res) => {
      console.log(res)
      form.authority = res.data.authority
      form.expireDate = res.data.expireDate
      form.avatar = res.data.avatar
      form.nickname = res.data.nickname
      form.gender = res.data.gender
      form.birthday = res.data.birthday
      form.region = res.data.region
      form.email = res.data.email
      form.wx = res.data.wx
      form.qq = res.data.qq
      form.desc = res.data.desc
      form.formStr = form.nickname + form.gender + form.birthday + form.region + form.email + form.wx + form.qq + form.desc
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'authority': form.authority,
        'expireDate': form.expireDate,
        'avatar': form.avatar,
        'nickname': form.nickname,
        'gender': form.gender,
        'birthday': form.birthday,
        'region': form.region,
        'email': form.email,
        'wx': form.wx,
        'qq': form.qq,
        'desc': form.desc,
        'formStr': form.formStr,
        'activeName': form.activeName,
        'messageList': form.messageList,
        'total': form.total,
        'page': form.page,
      }
      store.commit('setMeData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      form.authority = store.state.meData.authority
      form.expireDate = store.state.meData.expireDate
      form.avatar = store.state.meData.avatar
      form.nickname = store.state.meData.nickname
      form.gender = store.state.meData.gender
      form.birthday = store.state.meData.birthday
      form.region = store.state.meData.region
      form.email = store.state.meData.email
      form.wx = store.state.meData.wx
      form.qq = store.state.meData.qq
      form.desc = store.state.meData.desc
      form.formStr = store.state.meData.formStr
      form.activeName = store.state.meData.activeName
      form.messageList = store.state.meData.messageList
      form.total = store.state.meData.total
      form.page = store.state.meData.page
    }

    // 后台获取数据
    const requestMsgData = () => {
      let formData = new FormData()
      formData.append("page", form.page)
      formData.append("limit", form.limit)
      http({
        url: `/message`,
        method: 'post',
        data: formData
      }).then((res) => {
        console.log(res)
        console.log(res.data.data[0]['total'])
        form.total = res.data.data[0]['total']
        form.messageList = res.data.data[0].data
        // 当消息不存在时gin返回null问题对应
        if (form.messageList != null) {
          form.messageList.forEach(element => {
            if (element.readed == '1') {
              element.readed = '已读'
            } else {
              element.readed = '未读'
            }
          });
        }
        setStore()
      })
    }

    /**
     * 事件处理区域
     */

    // 充值点击事件 
    const handlePayClick = (e) => {
      let routeData = router.resolve({ path: '/pay' });
      window.open(routeData.href)
    }

    // 头像更换事件
    const handleAvatarSuccess = (e) => {
      console.log(e)
      // 上传文件没有错误的情况下，更新后台
      if (e.check_info != "") {
        ElMessage.error(e.check_info)
        return
      }
      let formData = new FormData()
      formData.append("avatar", e.data) // 文件服务器返回的文件保存路径
      http({
        url: `/user_update_avatar`,
        method: 'post',
        data: formData
      }).then((res) => {
        // success()
        LStorage.setItem('avatar', e.data)
      })
      // 页面avatar更新
      form.avatar = e.data
      setStore()
      ElMessage.success('头像上传成功')
    }

    // 头像文件检查
    const beforeAvatarUpload = (e) => {
      // console.log(e)
      if (e.type !== 'image/jpeg' && e.type !== 'image/png') {
        ElMessage.error('请上传jpg或者png格式的头像')
        return false
      } else if (e.size / 1024 / 1024 > 1) {
        ElMessage.error('头像大小不能大于1MB')
        return false
      }
      return true
    }

    // 输入框变化事件
    const handleInputChange = (e) => {
      setStore()
    }

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      setStore()
    }

    // 按钮提交事件
    const onSubmit = () => {
      if (!formCheck()) {
        return
      }
      let formData = new FormData()
      formData.append("nickname", form.nickname)
      formData.append("gender", form.gender)
      formData.append("birthday", form.birthday)
      formData.append("region", form.region)
      formData.append("email", form.email)
      formData.append("wx", form.wx)
      formData.append("qq", form.qq)
      formData.append("desc", form.desc)
      http({
        url: `/user_update`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('修改成功')
        requestData()
      })
    }

    // 表单check
    const formCheck = () => {
      if (form.formStr === form.nickname + form.gender + form.birthday + form.region + form.email + form.wx + form.qq + form.desc) {
        ElMessage.error('没有修改')
        return
      }
      if (form.nickname.trim() === '') {
        ElMessage.error('请输入昵称')
        return false
      }
      if (form.gender.trim() === '') {
        ElMessage.error('请选择性别')
        return false
      }
      if (form.birthday.trim() === '') {
        ElMessage.error('请选择生日')
        return false
      }
      if (form.region.trim() === '') {
        ElMessage.error('请选择地区')
        return false
      }
      return true
    }

    // 分页变化事件
    const handlePageChange = (value) => {
      form.page = value
      requestMsgData()
    };

    // 初始化抽屉
    const initDrawer = () => {
      form.title = ''
      form.date = ''
      form.category = ''
      form.content = ''
      form.drawer = true
    }

    // 信息点击事件
    const handleMsgClick = (row) => {
      initDrawer()
      let formData = new FormData()
      formData.append("id", row._id)
      http({
        url: `/message_detail`,
        method: 'post',
        data: formData
      }).then((res) => {
        console.log(res)
        // form.srcList = [] // 清空图片浏览器，防止多余图片
        processMsgData(res)
        // 设置已读
        form.messageList.forEach(element => {
          if (element._id == row._id) {
            element.readed = '已读'
          }
        });
      })
    }

    // 加工新闻数据
    const processMsgData = (res) => {
      // console.log(res)
      form.title = res.data.data[0].title
      form.date = res.data.data[0].date
      form.category = res.data.data[0].category
      form.content = res.data.data[0].content
      // const imgArray = form.content.map(item => item.img)
      // if (imgArray !== '') {
      //   for (var item of imgArray){
      //     if (item != ''){
      //       form.srcList.push(item)
      //     }
      //   }
      // }
      drawerPage.value.scrollTop = 0 // 滚动条回到顶部
    }

    // 关闭drawer事件
    const handleClosed = (res) => {
      // requestMsgData()
    }

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.readed == '未读') {
        return { fontWeight: 'bold' }
      }
    }

    return {
      form,
      store,
      drawerPage,
      handlePayClick,
      handleAvatarSuccess,
      beforeAvatarUpload,
      handleInputChange,
      handleSelectChange,
      onSubmit,
      handlePageChange,
      handleMsgClick,
      handleClosed,
      cellStyle
    }
  }
}
</script>
<style lang="scss" scoped></style>


